import { render, staticRenderFns } from "./HeaderToolBarOld.vue?vue&type=template&id=8160b0ec"
import script from "./HeaderToolBarOld.vue?vue&type=script&lang=js"
export * from "./HeaderToolBarOld.vue?vue&type=script&lang=js"
import style0 from "./HeaderToolBarOld.vue?vue&type=style&index=0&id=8160b0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports